import * as yup from "yup";

export const listingAgentContactForm = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email.")
    .required("Please enter your email."),
  name: yup.string().required("Please enter your name."),
  message: yup
    .string()
    .min(5, "A message with a minimum of 5 characters is required.")
    .required("Please enter your message."),
  phone: yup.string().required("Please enter your phone number.")
});
